import { mapParamsBySchema } from '../../../util';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import Global from '../../../Services/Common/Global';
import { M_TCS_BASIC_Schema } from './M_TCS_BASIC_Schema';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';

/** TBM 이수현황 조회 GetTcsBasicR1 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const payload = mapParamsBySchema(
      M_TCS_BASIC_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.TBMCompletionStatus.getTcsBasicR1, payload);
  }, successOptions);
};